

// src/web/components/albumPage.jsx

import React from 'react'
import _ from 'lodash'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  Tab,
  Tabs
} from 'react-toolbox/lib/tabs'
import { InfiniteScroll } from './infinite-scroller'
import Loading from './loading.jsx'
import AlbumImageItem from './album-image-item'
import AlbumVideoItem from './album-video-item'
import AlbumFileItem from './album-file-item'


class AlbumImage extends React.Component {
  fetchImage = ()=> {
    !this.props.isFetching && this.props.fetchImage(this.props)
  }
  render() {
    const {
      t,
      images,
      hasMoreImage,
      isFetching,
      isFetchFailed,
      fetchImage,
      showImagesView,
    } = this.props

    return (
      <div style={{overflow: 'scroll', height: `calc(80vh - 52px)`,}}>
          <InfiniteScroll 
            pageStart={0}
            initialLoad={false}
            loadMore={this.fetchImage}
            hasMore={hasMoreImage && !isFetchFailed}
            loader={isFetching && <Loading />}
            useWindow={false}>
            <div style={{ display: 'grid', minWidth: '350px', gap: 4,gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gridAutoRows: 350}}>
            {images && _.map(images, (image)=> 
              <AlbumImageItem image={image} key={image.file_id} showImagesView={showImagesView}/>
            )}
            </div>
            {!isFetching && (!images || images.length == 0) &&
              <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:データがありません')}</div>
            }
          </InfiniteScroll>
      </div>
    )
  }
}

class AlbumVideo extends React.Component {
  fetchVideo = () => {
    !this.props.isFetching && this.props.fetchVideo(this.props)
  }
  render() {
    const {
      t,
      videos,
      hasMoreVideo,
      isFetching,
      isFetchFailed,
      showImagesView,
      fetchVideo,
    } =this.props

    return (
      <div style={{ overflow: 'scroll', height: `calc(80vh - 52px)`}}>
            <InfiniteScroll 
            pageStart={0}
            initialLoad={false}
            loadMore={this.fetchVideo}
            hasMore={hasMoreVideo && !isFetchFailed}
            loader={isFetching && <Loading />}
            useWindow={false}>
            <div style={{ display: 'grid', minWidth: '350px', gap: 4,gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gridAutoRows: 350}}>
              {videos && _.map(videos, (video)=> 
                <AlbumVideoItem video={video} key={video.video_id} showImagesView={showImagesView}/>
              )}
            </div>
            {!isFetching && (!videos || videos.length == 0) &&
              <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:データがありません')}</div>
            }
            </InfiniteScroll>
      </div>
    )
  }
}

class AlbumFile extends React.Component {
  fetchFile = ()=> {
    !this.props.isFetching && this.props.fetchFile(this.props)
  }
  render() {
    const {
      t,
      files,
      hasMoreFile,
      openPdf,
      chatRoomId,
      isFetching,
      isFetchFailed,
      fetchFile,
    } = this.props

    return(
      <div style={{ overflow: 'scroll', height: `calc(80vh - 52px)`}}> 
        <InfiniteScroll
            pageStart={0}
            initialLoad={false}
            loadMore={this.fetchFile}
            hasMore={hasMoreFile && !isFetchFailed}
            loader={isFetching && <Loading />}
            useWindow={false}>
            {files && _.map(files, (file)=>
              <AlbumFileItem file={file} key={file.file_id} openPdf={openPdf}/>
            )}
            {!isFetching && (!files || files.length == 0) &&
              <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:データがありません')}</div>
            }
          </InfiniteScroll>
      </div>
    )
  }
}

class AlbumPage  extends React.Component {
  changeTab = (tabIndex) => {
    this.props.updateUI({ tabIndex })
    this.props.onChangeTab(tabIndex, this.props)
  }
  render() {
    const {
      t,
      ui,
      isFetching,
      isFetchFailed,
      images,
      files,
      videos,
      hasMoreImage,
      hasMoreFile,
      hasMoreVideo,
      closeAlbum,
      open,
      onChangeTab,
      fetchImage,
      fetchVideo,
      fetchFile,
      clearGroupAlbum,
      showImagesView,
      openPdf,
    } = this.props
  
    return (
      <Dialog active={open}
        onOverlayClick={closeAlbum}
        onEscKeyDown={closeAlbum}
        actions={[{label: t('label:閉じる'), onClick: closeAlbum, raised: true}]}>
        <Tabs fixed index={ui.tabIndex} onChange={this.changeTab}>
          <Tab label={t('label:画像')}>
            <AlbumImage images={images} t={t} 
              fetchImage={fetchImage}
              showImagesView={showImagesView}
              hasMoreImage={hasMoreImage} 
              isFetching={isFetching} 
              isFetchFailed={isFetchFailed}/>
          </Tab>
          <Tab label={t('label:動画・音声')}>
            <AlbumVideo videos={videos} t={t} 
              fetchVideo={fetchVideo}
              showImagesView={showImagesView}
              hasMoreVideo={hasMoreVideo}
              isFetching={isFetching}
              isFetchFailed={isFetchFailed} />
          </Tab>
          <Tab label={t('label:ファイル')}>
            <AlbumFile files={files} t={t} 
              fetchFile={fetchFile}
              openPdf={openPdf}
              hasMoreFile={hasMoreFile}
              isFetching={isFetching}
              isFetchFailed={isFetchFailed}/>
          </Tab>
        </Tabs>
      </Dialog>
    )
  }
}

export default AlbumPage


// WEBPACK FOOTER //
// ./src/web/components/albumPage.jsx